import * as React from "react";
import User from "../../presentations/User";

const UserContainer = (props: any) => {

  const {data, activeSections, setActiveSections} = props;

  return (
    <div>
      <User data={data} activeSections={activeSections} setActiveSections={setActiveSections}></User>
    </div>
  );
};

export default UserContainer;
